import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SmsService {
  private apiUrl = 'http://localhost:3000/api/sms';

  constructor(private http: HttpClient) {}

  sendSms(to: string, body: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/send`, { to, body });
  }
}
